
import ClientOAuth2 from "client-oauth2";
import config from './config'

export const oauthClient= new ClientOAuth2({
  clientId: config.openIdDict.CLIENT_ID,
  clientSecret: config.openIdDict.CLIENT_SECRET,
  // accessTokenUri: "https://identity.dev.fringesecure.com/connect/token",
  // authorizationUri: "https://identity.dev.fringesecure.com/connect/authorize",
  accessTokenUri: config.openIdDict.TOKEN_URI,
  authorizationUri: config.openIdDict.AUTH_URI,
  redirectUri: `${window.location.origin}${config.openIdDict.REDIRECT_URI}`,
  //scopes: ['openid', 'email', 'roles', 'offline_access', 'api1'] //THIS DOES NOT WORK
  //scopes: 'openid email roles offline_access api1' //THIS DOES NOT WORK, but will this?
});
export const scopes =['openid', 'email', 'roles', 'offline_access', 'api1'];